import { combineReducers } from 'redux';
import { api } from './rootApi';
import notificationsSlice from './slices/notificationsSlice';
import favouritesSlice from './slices/favouritesSlice';
import playerSlice from './slices/playerSlice';
import praharSlice from './slices/praharSlice';
import usersSlice from './slices/usersSlice';
import authSlice from './slices/authSlice';

const rootReducer = combineReducers({
  auth: authSlice,
  notification: notificationsSlice,
  favourites: favouritesSlice,
  user: usersSlice,
  player: playerSlice,
  prahar: praharSlice,
  [api.reducerPath]: api.reducer,
});

export default rootReducer;
